import React from 'react';
import {Modal, ScrollView, View} from 'react-native';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import MainStyle from '../../../../../MainStyle';
import {colors} from '../../../../assets/styles/colors';
import {isFullSwing} from "../../../../constants";
import P from "../../../../lib/P";

type Props = { message: string, onClose: () => void };

const InvalidCodeModal = (props: Props) => {
  const {message} = props;

  return (
    <Modal animationType="fade" transparent visible={!!message} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <View style={[MainStyle.min_h_full, MainStyle.a_i_c, MainStyle.j_c_c]}>
            <Div w={390} h={isFullSwing ? undefined : 342} rounded={20} borderWidth={1}
                 borderColor={colors.settings_border} bg={isFullSwing ? '#131314' : colors.settings_bg}
                 py={isFullSwing ? 0 : 44} alignItems="center" overflow="hidden">
              <P fw="500" fs={26} lh={isFullSwing ? 48 : 26} mb={38} bg={isFullSwing ? '#252526' : undefined} w="100%"
                 ta="center">
                Invalid Code
              </P>

              <P fw="500" fs={22} mb={47} ta="center">{message}</P>

              <Button
                onPress={props.onClose} text="OK" w={240} fontWeight="600" color={isFullSwing ? 'white' : undefined}
                radius={isFullSwing ? 4 : undefined} bg={isFullSwing ? '#3369FF' : undefined} mb={40}
              />
            </Div>
          </View>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default React.memo(InvalidCodeModal);
